import { NavLink } from "react-router-dom";
import { Boxes, KeyRound, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ROLE_LABELS } from "./navConfig";

const linkCls = ({ isActive }) =>
  `nav-link flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-150 ${isActive ? "active" : ""}`;

export function SideNav({ groups, user, onChangePassword, onLogout }) {
  return (
    <aside className="nav-navy hidden md:flex fixed inset-y-0 left-0 w-60 flex-col border-r z-40">
      <div className="flex items-center gap-2 px-4 h-16 border-b border-white/10">
        <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center"><Boxes className="w-5 h-5 text-white" /></div>
        <div>
          <p className="font-heading font-bold text-lg leading-none tracking-wide text-white">WORLDITES</p>
          <p className="text-[10px] font-mono uppercase tracking-widest text-white/60">International Packaging</p>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto p-3 space-y-1" data-testid="side-nav">
        {groups.map((g, gi) => (
          <div key={g.section || `group-${gi}`}>
            {g.section && (
              <p className="nav-section px-3 pt-3 pb-1 text-[9px] font-mono uppercase tracking-widest" data-testid={`nav-section-${g.section.toLowerCase().replace(/\s+/g, "-")}`}>
                {g.section}
              </p>)}
            {g.items.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.to === "/"} className={linkCls} data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
                <n.icon className="w-4 h-4" />
                {n.label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
      <div className="p-3 border-t border-white/10">
        <div className="flex items-center gap-2 px-2 py-2">
          <div className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-xs font-bold">
            {user?.name?.[0]?.toUpperCase() || "U"}
          </div>
          <div className="min-w-0">
            <p className="text-sm font-medium truncate text-white" data-testid="sidebar-user-name">{user?.name}</p>
            <p className="text-[10px] font-mono uppercase tracking-widest text-white/60">{ROLE_LABELS[user?.role] || user?.role}</p>
          </div>
        </div>
        <Button variant="ghost" size="sm" className="w-full justify-start text-white/70 hover:text-white hover:bg-white/10" onClick={onChangePassword} data-testid="change-password-button">
          <KeyRound className="w-4 h-4 mr-2" /> Change password
        </Button>
        <Button variant="ghost" size="sm" className="w-full justify-start text-white/70 hover:text-white hover:bg-white/10" onClick={onLogout} data-testid="logout-button">
          <LogOut className="w-4 h-4 mr-2" /> Sign out
        </Button>
      </div>
    </aside>
  );
}

export function MobileNav({ items }) {
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-card/95 backdrop-blur-md border-t border-border flex justify-around py-2" data-testid="mobile-nav">
      {items.slice(0, 5).map((n) => (
        <NavLink
          key={n.to}
          to={n.to}
          end={n.to === "/"}
          data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
          className={({ isActive }) =>
            `flex flex-col items-center gap-0.5 px-3 py-1 text-[10px] font-mono uppercase tracking-wide transition-colors duration-150 ${
              isActive ? "text-primary" : "text-muted-foreground"
            }`
          }
        >
          <n.icon className="w-5 h-5" />
          {n.label}
        </NavLink>
      ))}
    </nav>
  );
}
